import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// Logical area: Offline General Strings
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.ui.Offline.';

  public static readonly operationFailed = `${Id.prefix}operationFailed`;
  public static readonly systemOffline = `${Id.prefix}systemOffline`;
}

export class LangOffline {
  private constructor() {}

  public static operationFailed(): string {
    return interpolate(Id.operationFailed);
  }
  public static systemOffline(): string {
    return interpolate(Id.systemOffline);
  }
}

export class OfflineModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // General
    register.add(
      Id.operationFailed,
      'The operation could not be completed due to an issue communicating with the online services',
      'Offline operation failed message'
    );
    register.add(Id.systemOffline, 'System Offline', 'System offline message');
  }
}
